module.exports = __webpack_public_path__ + "static/media/arrow.412d2d7e.svg";